import AvatarImg from './avatar.png';
import ThumbImg from './thumb.png';

export default {
  avatar: AvatarImg,
  thumb: ThumbImg,
  author: 'Mark Fielding',
  url: '/raymondlightyear',
  footnote: null,
};
